import React from 'react';
import _ from 'lodash';
import RoleButton from './RoleButton';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import { USER_ROLES } from '../../utilities/constants';
import {
  isPrimaryCompanyRoleId,
  isTargetRoleId,
} from '../../utilities/roleUtility';

/**
 * @description 元請ユーザー(本社管理者、支店管理者、現場監督)専用ボタン
 * propsに見たい対象のuser{userId, company}を渡してれば、元請け固有かも判別してくれる
 */
const PrimeContractorButton = props => {
  let res = false;

  if (_.isUndefined(props.user)) {
    // userを渡してなければデフォルトはtrue
    res = true;
  } else if (
    // 渡してるけどデータがないときはまだローディング中なので出さない
    _.isUndefined(props.user.roleId) ||
    _.isUndefined(props.user.company)
  ) {
    res = false;
  } else {
    // 以下の時表示
    // ・company.joining_flag = 0 (元請固有)かつ、
    // ・user.role_code = 6（職長）
    res =
      props.user.company.joining_flag === 0 &&
      isTargetRoleId([USER_ROLES.foreman], props.user.roleId)
        ? true
        : false;
  }

  return (
    <RoleButton
      label={props.label}
      buttonClass={props.buttonClass}
      onClick={props.onClick}
      show={res && isPrimaryCompanyRoleId(LocalStorageService.getRoleId())}
    />
  );
};

export default PrimeContractorButton;



// WEBPACK FOOTER //
// ./src/components/button/PrimeContractorButton.jsx